<script>
	import { Basket } from '../../stores/basket';
	import { Modal } from '../../stores/modal';
	import ProductDetails from '../modals/ProductDetails.svelte';
	import textFit from 'textfit';
	import {onMount} from 'svelte';
	let titleEl;
	export let product;

	// onMount(() => {
	// 	textFit(titleEl, {multiLine: false, reProcess: true,  detectMultiLine: false, maxFontSize: 20});
	// })

	let selectedSize=0;
	export let cssClass = "col-6 col-md-4";
</script>
<div class="{cssClass}">
	<a class="item-box" href="/products/{product.slug}">
		<div class="product text-center">
			<img src={product.item_img} class="img-responsive">
			<!-- <div class="caption"> -->
				<!-- <h5 bind:this={titleEl}>{product.name}</h5> -->
				<!-- <h5>{product.name}</h5> -->
			<!-- <h5>₹ 499</h5>
			<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit</p>
			<div class="actions">
				<a href="/products/1" class="btn btn-primary" role="button">View</a><a href="#" class="btn btn-primary" role="button">Add to basket</a>
			</div> -->
			<!-- </div> -->
		</div>
		<div class="caption">
			<h5>{product.name}</h5>
		</div>
	</a>
	<div class="d-flex mt-13 align-items-center actions-for-product">
		<div class="mobile-center">
			<span class="d-inline-block">
				<select class="form-control sizes-options" bind:value={selectedSize}>
					{#each product.pricelist_by_avl_sizes as size, i}
						<option value={i}>
							{size.size}
						</option>
					{/each}
				</select>
			</span>
			<span class="d-inline-block cost-box">
				&#8377; {product.pricelist_by_avl_sizes.length ? product.pricelist_by_avl_sizes[selectedSize].cost : ''}
			</span>
		</div>
		<div class="ms-auto">
			<button class="add-btn" on:click|preventDefault={e => {
				Modal.open(ProductDetails, {
					title: product.name,
					product: product,
					selectedSize
				})
			}}>
				{#if $Basket.items.find(item => item.item_num == product.item_num)}
					UPDATE
				{:else}
					ADD
				{/if}
			</button>
		</div>
	</div>
</div>
<style lang="scss">

	.item-box {
		display: block;
		margin: 1.5em 0 0.5em 0;
	}

	.product{
		border: 4px solid rgba(247, 195, 114, 0.7);
		// min-height: 296px;
		overflow: hidden;
		border-radius: 12px 12px 0 0;
		position: relative;
		padding: 0;

		&:before {
			content: '';
			position: absolute;
			left: 3px;
			right: 3px;
			bottom: 3px;
			top: 3px;
			border: 2px solid rgba(247, 195, 114, 0.5);
			z-index: 9;
			border-radius: 8px;
		}

		img{
			object-fit: cover;
			max-height: 242px;
			width: 100%;
		}

		.in-cart{
			position: absolute;
			right: 50px;
			top: 50px;
			text-shadow: 0 0 5px rgba(0,0,0,66%);
		}

		.caption {
			// position: absolute;
			bottom: 3px;
			left: 3px;
			right: 3px;
			background: rgba(166, 144, 107, 0.9);
			border-radius: 0 0 8px 8px;

			h5 {
				padding: 6px 4px;
				font-family: var(--primary-font);
				color: #434343;
				margin: 0;
				font-size: 15px;
				text-transform: uppercase;
				position: relative;
				min-height: 48px;
				display: flex;
				align-items: center;
				justify-content: center;
				text-align: center;
			}
		}

		.actions {

			.btn{
				margin: 1em;
			}
		}
	}

	.sizes-options {
		background: #ececec;
		color: #434343;
		font-family: var(--primary-font);
		// font-weight: 600;
		font-size: 13px;
		border-radius: 8px;
		border: none;
		text-align: center;
		text-transform: uppercase;
		// min-width: 95px;
		height: 28px;
		padding: 0;
		line-height: 20px;
		padding: 0 3px;
	    border: 2px solid rgba(247, 195, 114, 1);
	}

	.cost-box {
		background: #ececec;
		margin-left: 8px;
		font-family: var(--primary-font);
		// font-weight: 600;
		font-size: 13px;
		border-radius: 8px;
		border: none;
		text-align: center;
		text-transform: uppercase;
		min-width: 95px;
		display: inline-block;
		max-width: 100px;
		height: 28px;
		line-height: 20px;
		color: #434343;
		padding: 2px 3px;
		border: 2px solid rgba(247, 195, 114, 1);
	}

	.add-btn {
		background: #f7c372;
		// background: #ececec;
		font-size: 13px;
		color: #434343;
		height: 28px;
		line-height: 20px;
		min-width: 100px;
		border-radius: 8px;
		border: none;
		outline: none;
		font-family: var(--primary-font);
		// font-weight: 600;
		padding: 0 3px;
		border: 2px solid rgba(247, 195, 114, 1);
	}

	.mt-12 {
		margin-top: 13px !important;
	}

	.ms-auto {
		margin-left: auto;
	}

	.caption {
		// position: absolute;
		bottom: 3px;
		left: 3px;
		right: 3px;
		background: rgba(166, 144, 107, 0.9);
		border-radius: 0 0 8px 8px;

		h5 {
			padding: 6px 4px;
			font-family: var(--primary-font);
			color: #434343;
			margin: 0;
			font-size: 15px;
			text-transform: uppercase;
			position: relative;
			min-height: 48px;
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;
		}
	}
</style>